export default __webpack_public_path__ + "static/2_months-0269fd3e9e480dd03ba65262d602160a.jpeg";